<script>
  import Panzoom from '@panzoom/panzoom';

  export default {
    props: {
      active: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        panzoom: null,
      };
    },
    watch: {
      active(val) {
        if (!val) {
          this.deactivate();
          return;
        }

        this.activate();
      },
    },
    mounted() {
      if (this.active) {
        this.activate();
      }
    },
    beforeDestroy() {
      this.deactivate();
    },
    methods: {
      onPanzoomChange(e) {
        if (!this.panzoom) return;
        this.$emit('panzoomchange', e);
      },
      onPanzoomEnd(e) {
        if (!this.panzoom) return;

        if (e.detail.scale <= 1) {
          this.panzoom.pan(0, 0, { force: true });
          return;
        }

        const width = this.$el.offsetWidth;
        const height = this.$el.offsetHeight;
        const x = e.detail.x;
        const y = e.detail.y;

        const xMax = (width * 0.4) * (x < 0 ? -1 : 1);
        const yMax = (height * 0.3) * (y < 0 ? -1 : 1);

        if ((x < 0 && x < xMax) || (x > 0 && x > xMax) || (y < 0 && y < yMax) || (y > 0 && y > yMax)) {
          this.panzoom.zoom(1, { animate: false, force: true });
          this.panzoom.pan(0, 0, { force: true });
        }
      },
      activate() {
        if (this.panzoom) return;
        this.panzoom = Panzoom(this.$el, {
          maxScale: 5,
          minScale: 1,
          panOnlyWhenZoomed: true,
          handleStartEvent: (e) => {
            e.preventDefault();

            const scale = this.panzoom.getScale();
            const { x, y } = this.panzoom.getPan();

            if (scale !== 1 || x !== 0 || y !== 0) {
              e.stopPropagation();
            }
          },
        });

        this.$el.addEventListener('panzoomchange', this.onPanzoomChange);
        this.$el.addEventListener('panzoomend', this.onPanzoomEnd);
      },
      deactivate() {
        if (!this.panzoom) return;
        this.$el.addEventListener('panzoomchange', this.onPanzoomChange);
        this.$el.addEventListener('panzoomend', this.onPanzoomEnd);
        this.panzoom.destroy();
        this.panzoom = null;
      },
    },
  };
</script>

<template>
  <div>
    <slot />
  </div>
</template>
